import { withTracker } from 'meteor/react-meteor-data';
import { Meteor } from 'meteor/meteor';
import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty, isEqual, map, find, cloneDeep, filter } from 'lodash';
import { Bert } from 'meteor/themeteorchef:bert';

import { Box, Stack, Menu, MenuItem, Typography, Modal, Button } from '@mui/material';
import SwitchVideoIcon from '@mui/icons-material/SwitchVideo';
import PlayCircleOutlineRoundedIcon from '@mui/icons-material/PlayCircleOutlineRounded';
import PauseCircleOutlineRoundedIcon from '@mui/icons-material/PauseCircleOutlineRounded';
import SettingsIcon from '@mui/icons-material/Settings';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import PublicIcon from '@mui/icons-material/Public';
import PublicOffIcon from '@mui/icons-material/PublicOff';
import StreetviewIcon from '@mui/icons-material/Streetview';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import DeleteIcon from '@mui/icons-material/Delete';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import EditIcon from '@mui/icons-material/Edit';
import { renderIconButton, renderTable, renderTextField } from '../MaterialMUIComponent';

import Videos, { VIDEO_COORDINATE_DATA_TYPES } from '../../../api/Videos/Videos';
import * as videoOps from '../../../api/Videos/video-operations';
import * as videoCalculate from '../../../api/Videos/videos-calculations';
import * as mapOps from '../../../api/Maps/map-operations';
import * as annotationOps from '../../../api/Annotations/annotation-operations';
import * as templateOps from '../../../api/AnnotationTemplates/annotation-template-operations';

import Loading from '../Loading';
import VideoAnnotationsMaps from '../AnnotationsMaps/VideoAnnotationsMaps';
import ViewAnnotationOneByOne from '../ViewAnnotationOneByOne';
import AnnotationMapsEditor from '../AnnotationsMaps/AnnotationMapsEditor';
import ImportAnnotationMaps from '../AnnotationsMaps/ImportAnnotationMaps';
import ViewGeometriesOnMap from '../ViewGeometriesOnMap';

import { exportTextToLocalFile } from '../../../modules/export-import-files';
import methodPromise from '../../../modules/method-promise-wrapper';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import useTimeStore from '../ZustandProvider';

const ANCHOR_DEFAULT_ICONBTTON = 35;
const NotesComponent = props => {
  const {
    isMobile,
    loading,
    videosDataBase,
    MapProps,
    notesProps,
    previousStates,
    saveStates,
    ...rest
  } = props;
  if (loading) return <Loading />;
  const { geomotionVideoLinkAPI } = Meteor.settings.public;
  const isMapLoaded = useTimeStore(state => state.isMapLoaded);
  const setShowNotesOnMap = useTimeStore(state => state.setShowNotesOnMap);
  const showNotesOnMap = useTimeStore(state => state.showNotesOnMap);

  const {
    entWine,
    interval,
    showStreetView,
    centerNotes,
    centerNotesDefault,
    showTrack,
    showAnnotations,
    showAllNotes,
    showAllTracks,
    showNotes,
    showNotesDefault,
    showGeomotion,
    showGeomotionPublic,
    showCreateAnnotation,
    showUpdateAnnotation,
    showDeleteAnnotation,
    showImportAnnotation,
    showExportAnnotation,
    showVideo
  } = notesProps;

  const [anchorMenuVideo, setAnchorMenuVideo] = React.useState({ anchorEl: null, top: 0, left: 0 });
  const [anchorMenuSettings, setAnchorMenuSettings] = React.useState({
    anchorEl: null,
    top: 0,
    left: 0
  });
  const [anchorMenuRemove, setAnchorMenuRemove] = React.useState({
    anchorEl: null,
    top: 0,
    left: 0
  });
  const [anchorMenuImport, setAnchorMenuImport] = React.useState({
    anchorEl: null,
    top: 0,
    left: 0
  });
  const [anchorMenuExport, setAnchorMenuExport] = React.useState({
    anchorEl: null,
    top: 0,
    left: 0,
    openMenuOneByGPS: false,
    openMenuAllbyGPS: false,
    openMenuByTemplate: false
  });
  const openMenuVideos = Boolean(anchorMenuVideo.anchorEl);
  const openMenuSettings = Boolean(anchorMenuSettings.anchorEl);
  const openMenuRemove = Boolean(anchorMenuRemove.anchorEl);
  const openMenuImport = Boolean(anchorMenuImport.anchorEl);
  const openMenuExport = Boolean(anchorMenuExport.anchorEl);

  const [openModalGeomotion, setOpenModalGeomotion] = React.useState(false);
  const [openModalGeomotionPublic, setOpenModalGeomotionPublic] = React.useState(false);
  const [openModalProfile, setOpenModalProfile] = React.useState(false);

  const [isStart, setIstart] = React.useState(true);
  const startVideo = !isEmpty(videosDataBase)
    ? { video: videosDataBase[0], index: 0 }
    : { video: {}, index: -1 };
  const { prevVideo, prevIndexAnnotation, totalAnnotations } = previousStates;
  const startPrevVideo = { video: prevVideo.video, index: prevVideo.index };
  const isPrevStates = !isEqual(prevVideo.index, -1) && !isEmpty(prevVideo.video);
  const startStates = {
    startVideo: isPrevStates ? startPrevVideo : startVideo,
    startAnnotation: isPrevStates ? prevIndexAnnotation : 0,
    startTotalAnnotations: isPrevStates ? totalAnnotations : 0
  };

  const [videoSelected, setVideoSelected] = React.useState(startStates.startVideo);
  const isVideoLine =
    videoOps.getCoordinatesDataType(videoSelected.video) !== VIDEO_COORDINATE_DATA_TYPES.POINT;
  const videoProfile = find(entWine, ['videoId', videoOps.getId(videoSelected.video)]);
  const [annotationsVideo, setAnnotationsVideo] = React.useState([]);
  const [annotation, setAnnotation] = React.useState({
    index: startStates.startAnnotation,
    total: startStates.startTotalAnnotations,
    element: !isEmpty(annotationsVideo) ? annotationsVideo[startStates.startAnnotation] : {}
  });
  const coordsAnnotation = !isEmpty(annotation.element)
    ? annotationOps.getCoordinates(annotation.element)
    : [];

  const [carrouselAnnotation, setCarrouselAnnotation] = React.useState({
    intervalValue: String(interval.value),
    playCarrousel: false,
    intervalID: null
  });

  const [isEditorMode, setIsEditorMode] = React.useState({
    isEditor: false,
    isUpdateEditor: false
  });
  const [importMode, setImportMode] = React.useState({
    isImport: false,
    fileName: '',
    fileJson: {},
    methodImport: 'none'
  });

  const isEditorShow = isEditorMode.isEditor || isEditorMode.isUpdateEditor;

  const callModules = async video => {
    try {
      const annotations = await methodPromise(
        'annotations.annotationsFromVideo',
        videoOps.getId(video.video)
      );
      const newAnnotations = !isEmpty(annotations) ? annotations : [];
      setAnnotationsVideo(newAnnotations);
      const annotationSave = !isEmpty(newAnnotations) ? newAnnotations[0] : {};
      setAnnotation({
        index: isPrevStates && isStart ? prevIndexAnnotation : 0,
        total: newAnnotations.length,
        element:
          isPrevStates && isStart && !isEmpty(newAnnotations)
            ? newAnnotations[prevIndexAnnotation]
            : annotationSave
      });
      if (isStart) setIstart(false);
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  const annotationByTemplate = () => {
    const templateArray = [];
    map(annotationsVideo, el => {
      const template = annotationOps.getTemplate(el);
      if (!templateArray.includes(templateOps.getName(template)))
        templateArray.push(templateOps.getName(template));
    });
    return templateArray;
  };

  const playCarrousel = () => {
    const time = Number(carrouselAnnotation.intervalValue) * 1e3;
    let count = annotation.index;
    const intervalID = setInterval(() => {
      count += 1;
      if (count > annotation.total - 1) count = 0;
      setAnnotation({ ...annotation, index: count });
    }, time);
    setCarrouselAnnotation({ ...carrouselAnnotation, playCarrousel: true, intervalID });
  };

  const handleRemoveAnnotation = async method => {
    const videoId = videoOps.getId(videoSelected.video);
    const isValid =
      MapProps && !isEmpty(mapOps.getSharedConfiguration(MapProps.map))
        ? mapOps.getSharedConfiguration(MapProps.map).deleteAnnotations
        : false;
    // eslint-disable-next-line no-alert
    if (window.confirm('Are you sure? This is permanent!'))
      try {
        const methodCall = isEqual(method, 'all')
          ? 'annotations.hardManyDelete'
          : 'annotations.hardDelete';
        const idcall = isEqual(method, 'all') ? videoId : annotationOps.getId(annotation.element);
        await methodPromise(methodCall, idcall, isValid);
        const newIndex = annotation.index > 0 ? annotation.index - 1 : 0;
        setAnnotation({
          index: isEqual(method, 'all') ? 0 : newIndex,
          total: isEqual(method, 'all') ? 0 : annotation.total - 1,
          element: isEqual(method, 'all') ? {} : annotationsVideo[newIndex]
        });
        Bert.alert('Annotation deleted', 'success');
      } catch (e) {
        handleErrorInClient(e);
      }
  };

  const handleImportAnnotation = method => {
    const handleFileImportCSV = event => {
      const filePath = event.target.value;
      const pathArrayFile = filePath.split('\\');
      const nameFileWithExtension = pathArrayFile[pathArrayFile.length - 1];
      const nameFileArray = nameFileWithExtension.split('.');
      const nameFile = nameFileArray[0];

      const file = event.target.files[0];
      const fileReader = new FileReader();
      fileReader.readAsText(file);
      fileReader.onload = async () => {
        const { result } = fileReader;
        const parsedText = JSON.parse(result);
        const fileImport = parsedText[0];
        const annotationImport = isEmpty(fileImport) ? parsedText : fileImport;
        setImportMode({
          isImport: true,
          fileName: nameFile,
          fileJson: annotationImport,
          methodImport: method
        });
      };
      fileReader.onerror = () => {
        Bert.alert('Error on load file', 'danger');
      };
    };

    const inputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.onchange = handleFileImportCSV;
    inputElement.click();
  };

  const handleExport = async (video, method, syncGPS = false) => {
    const cloneAnnotation = cloneDeep(annotation.element);
    const allAnnotations = await methodPromise('videos.exportAnnotations', videoOps.getId(video));
    const videoTemplates = videoOps.getAnnotationTemplates(video);
    const namesTemplates = videoTemplates.map(element => element.name);
    let nameFile = `${videoOps.getName(video)}.json`;
    let content = {};
    try {
      switch (method) {
        case 'actualAnnotat ion':
          if (syncGPS) {
            const newTimeGPS = videoCalculate.calculateTimeGPSAnnotation(video, cloneAnnotation);
            cloneAnnotation.timeGPS = newTimeGPS;
          }
          nameFile = !syncGPS
            ? `${videoOps.getName(video)}_annotation.json`
            : `${videoOps.getName(video)}_GPS_annotation.json`;
          content = { annotations: [cloneAnnotation] };
          break;
        case 'annotations':
          if (syncGPS) {
            const newAnnotations = map(allAnnotations.annotations, element => {
              const item = element;
              const newTimeGPS = videoCalculate.calculateTimeGPSAnnotation(video, item);
              item.timeGPS = newTimeGPS;
              return item;
            });
            const exportItemGPS = { annotations: newAnnotations };
            nameFile = `${videoOps.getName(video)}_GPS_annotations.json`;
            content = exportItemGPS;
          } else {
            nameFile = `${videoOps.getName(video)}_annotations.json`;
            content = allAnnotations;
          }
          break;
        case 'video':
          content = video;
          break;
        default:
          if (namesTemplates.includes(method)) {
            const newAnnotationByTemplate = filter(annotationsVideo, element => {
              const template = annotationOps.getTemplate(element);
              return template.name === method;
            });
            nameFile = `${videoOps.getName(video)}_${method}.json`;
            content = newAnnotationByTemplate;
          }
          break;
      }

      exportTextToLocalFile(nameFile, JSON.stringify(content, null, '  '));
      setAnchorMenuExport({ ...anchorMenuExport, anchorEl: null });
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  const renderManyIconButtons = array =>
    map(
      array,
      item =>
        item.isShow &&
        renderIconButton({
          key: item.key,
          onClick: item.onClick,
          icon: item.icon,
          titleTooltip: item.title,
          disabled: item.disabled,
          moreProps: { ...item.moreProps }
        })
    );
  const renderManyTextField = array =>
    map(array, item =>
      renderTextField({
        type: item.type,
        key: item.key,
        label: item.label,
        style: { ...item.style },
        moreProps: { ...item.moreProps }
      })
    );

  const iconsMenuSettings = [
    {
      function: () => setIsEditorMode({ isEditor: true, isUpdateEditor: false }),
      icon: <NoteAddIcon style={{ color: 'white' }} />,
      title: 'Create New Annotation',
      isDisabled: isEmpty(videoSelected.video) || !showCreateAnnotation,
      key: 'createAnnotation'
    },
    {
      function: () => setIsEditorMode({ isEditor: false, isUpdateEditor: true }),
      icon: <EditIcon style={{ color: 'white' }} />,
      title: 'Edit Annotation',
      isDisabled: isEmpty(annotation.element) || !showUpdateAnnotation,
      key: 'editAnnotation'
    },
    {
      function: event =>
        setAnchorMenuRemove({
          anchorEl: event.currentTarget,
          left: event.clientX,
          top: event.clientY
        }),
      icon: <DeleteIcon style={{ color: 'white' }} />,
      title: 'Delete Annotation',
      isDisabled: isEmpty(annotation.element) || !showDeleteAnnotation,
      key: 'deleteAnnotation'
    },
    {
      function: event =>
        setAnchorMenuImport({
          anchorEl: event.currentTarget,
          left: event.clientX,
          top: event.clientY
        }),
      icon: <UploadFileIcon style={{ color: 'white' }} />,
      title: 'Import Annotation',
      isDisabled: isEmpty(videoSelected.video) || !showImportAnnotation,
      key: 'importAnnotation'
    },
    {
      function: event =>
        setAnchorMenuExport({
          anchorEl: event.currentTarget,
          left: event.clientX,
          top: event.clientY
        }),
      icon: <SimCardDownloadIcon style={{ color: 'white' }} />,
      title: 'Export Annotation',
      isDisabled: isEmpty(annotation.element) || !showExportAnnotation,
      key: 'exportAnnotation'
    },
    {
      function: () => setOpenModalGeomotionPublic(true),
      icon: <PublicIcon style={{ color: 'white' }} />,
      title: 'Geomotion public',
      isDisabled: !showGeomotionPublic && !videoOps.isShared(videoSelected.video),
      key: 'geomotionPublic'
    },
    {
      function: () => setOpenModalGeomotion(true),
      icon: <PublicOffIcon style={{ color: 'white' }} />,
      title: 'Geomotion private',
      isDisabled: isEmpty(videoSelected.video) || !showGeomotion,
      key: 'geomotionPrivate'
    },
    {
      function: () => {},
      icon: <StreetviewIcon style={{ color: 'white' }} />,
      title: 'Street view',
      isDisabled: !showStreetView,
      key: 'showStreetView',
      moreProps: {
        target: 'blank',
        href: !isEmpty(coordsAnnotation)
          ? `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${coordsAnnotation[1]},${coordsAnnotation[0]}`
          : ''
      }
    },
    {
      function: () => setOpenModalProfile(true),
      icon: <ShowChartIcon style={{ color: 'white' }} />,
      title: 'Show profile video',
      isDisabled: isEmpty(videoProfile) || !isVideoLine,
      key: 'showProfileVideo'
    }
  ];

  const renderModal = ({ openModalProp, onCloseProp, srcProp, titleProp }) => {
    return (
      <Modal
        open={openModalProp}
        onClose={onCloseProp}
        style={{
          bgcolor: 'white'
        }}
      >
        <Box backgroundColor="white" width="100%" height="100%">
          <Button color="success" variant="outlined" onClick={onCloseProp}>
            Close
          </Button>
          <iframe title={titleProp} src={srcProp} width="100%" height="95%" />
        </Box>
      </Modal>
    );
  };

  const elementsRowOneColumnOne = [
    <Stack
      key="row1-column1-selector-videos"
      direction="row"
      display="flex"
      justifyContent="flex-start"
      style={{ backgroundColor: '#2A3F90', width: '100%', height: '100%' }}
    >
      {renderManyIconButtons([
        {
          isShow: true,
          key: 'boton-menu-videos',
          onClick: event =>
            setAnchorMenuVideo({
              anchorEl: event.currentTarget,
              left: event.clientX,
              top: event.clientY
            }),
          icon: <SwitchVideoIcon style={{ color: 'white' }} />,
          titleTooltip: 'Videos',
          disabled: isEmpty(videosDataBase)
        }
      ])}
      <Typography
        style={{ color: 'white', height: '50%', marginTop: '3%', fontSize: '15px' }}
      >{`${videoSelected.index + 1}/${videosDataBase.length}`}</Typography>
      <Typography
        style={{
          color: 'white',
          height: '50%',
          marginTop: '3%',
          fontSize: '15px',
          marginLeft: '2%'
        }}
      >
        {videoOps.getName(videoSelected.video)}
      </Typography>
      <Menu
        key="menu-videos"
        open={openMenuVideos}
        anchorEl={anchorMenuVideo.anchorEl}
        onClose={() => setAnchorMenuVideo({ ...anchorMenuVideo, anchorEl: null })}
        style={{
          left: `${anchorMenuVideo.left}px`,
          top: `${anchorMenuVideo.top}px`
        }}
      >
        {!isEmpty(videosDataBase) &&
          videosDataBase.map((vid, index) => {
            return (
              <MenuItem
                autoFocus={isEqual(videoOps.getId(videoSelected.video), videoOps.getId(vid))}
                selected={isEqual(videoOps.getId(videoSelected.video), videoOps.getId(vid))}
                key={videoOps.getId(vid)}
                onClick={() => {
                  setVideoSelected({ video: vid, index });
                  setAnchorMenuVideo({ ...anchorMenuVideo, anchorEl: null });
                }}
              >{`${videoOps.getName(vid)}`}</MenuItem>
            );
          })}
      </Menu>
    </Stack>
  ];

  const elementsRowOneColumnTwo = [
    <Stack
      key="row1-column2-buttons-options"
      direction="row"
      display="flex"
      justifyContent="flex-end"
      style={{ backgroundColor: '#2A3F90', width: '100%', height: '100%' }}
    >
      {interval.show && annotation.total > 1 && (
        <>
          {!carrouselAnnotation.playCarrousel &&
            renderManyTextField([
              {
                key: 'textfield-change-interval-carrousel',
                type: 'number',
                label: '',
                style: { alignItems: 'end' },
                moreProps: {
                  InputProps: {
                    inputProps: { min: 0 },
                    style: { width: '45%', backgroundColor: 'white', height: '70%', top: '15%' }
                  },
                  onChange: event =>
                    setCarrouselAnnotation({
                      ...carrouselAnnotation,
                      intervalValue: String(event.target.value)
                    }),
                  value: carrouselAnnotation.intervalValue
                }
              }
            ])}
          {renderManyIconButtons([
            {
              isShow:
                interval.show &&
                !carrouselAnnotation.playCarrousel &&
                !isEqual(annotation.total, 0),
              key: 'boton-start-carrousel',
              onClick: () => {
                playCarrousel();
              },
              icon: <PlayCircleOutlineRoundedIcon style={{ color: 'white' }} />,
              titleTooltip: 'Start Carrousel',
              disabled: isEmpty(videosDataBase)
            },
            {
              isShow:
                interval.show && carrouselAnnotation.playCarrousel && !isEqual(annotation.total, 0),
              key: 'boton-pause-carrousel',
              onClick: () => {
                clearInterval(carrouselAnnotation.intervalID);
                setCarrouselAnnotation({
                  ...carrouselAnnotation,
                  playCarrousel: false,
                  intervalID: null
                });
              },
              icon: <PauseCircleOutlineRoundedIcon style={{ color: 'white' }} />,
              titleTooltip: 'Pause Carrousel',
              disabled: isEmpty(videosDataBase)
            }
          ])}
        </>
      )}
      {!isEmpty(videoSelected.video) && isMapLoaded && (
        <ViewGeometriesOnMap
          videosId={map(videosDataBase, vid => videoOps.getId(vid))}
          viewButtonGeometry={showNotes}
          viewButtonCenter={centerNotes}
          startShowGeometries={showNotesDefault}
          startCenterGeometries={centerNotesDefault}
          showAnnotations={showAnnotations}
          showTrack={showTrack}
          showAllAnnotations={showAllNotes}
          showAllTracks={showAllTracks}
          selectedAnnotation={annotation.element}
          videoSelected={videoSelected.video}
          handleAnnotation={(newAnnotation, newIndex) =>
            setAnnotation({
              ...annotation,
              index: newIndex,
              element: newAnnotation
            })
          }
        />
      )}
      {renderManyIconButtons([
        {
          isShow: true,
          key: 'boton-pause-carrousel',
          onClick: event => {
            setAnchorMenuSettings({
              anchorEl: event.currentTarget,
              left: event.clientX,
              top: event.clientY
            });
          },
          icon: <SettingsIcon style={{ color: 'white' }} />,
          titleTooltip: 'Annotations options',
          disabled: isEmpty(videosDataBase)
        }
      ])}
      <Menu
        key="menu-settings-annotations"
        open={openMenuSettings}
        anchorEl={anchorMenuSettings.anchorEl}
        onClose={() => setAnchorMenuSettings({ ...anchorMenuSettings, anchorEl: null })}
        MenuListProps={{ sx: { py: 0 } }}
        style={{
          left: `${anchorMenuSettings.left - ANCHOR_DEFAULT_ICONBTTON}px`,
          top: `${anchorMenuSettings.top}px`
        }}
      >
        {!isEmpty(iconsMenuSettings) &&
          iconsMenuSettings.map(
            item =>
              !item.isDisabled && (
                <MenuItem
                  style={{ backgroundColor: 'grey', padding: 0 }}
                  key={`itemMenu-${item.key}`}
                >
                  {renderManyIconButtons([
                    {
                      isShow: true,
                      key: `boton-settings-${item.key}`,
                      onClick: item.function,
                      icon: item.icon,
                      titleTooltip: item.title,
                      disabled: isEmpty(videosDataBase),
                      moreProps: { ...item.moreProps }
                    }
                  ])}
                </MenuItem>
              )
          )}
      </Menu>
      <Menu
        key="menu-remove-annotations"
        open={openMenuRemove}
        anchorEl={anchorMenuRemove.anchorEl}
        onClose={() => setAnchorMenuRemove({ ...anchorMenuRemove, anchorEl: null })}
        style={{
          left: `${anchorMenuRemove.left}px`,
          top: `${anchorMenuRemove.top}px`
        }}
      >
        <MenuItem
          disabled={isEmpty(annotation.element)}
          onClick={() => {
            setAnchorMenuRemove({ ...anchorMenuRemove, anchorEl: null });
            handleRemoveAnnotation('actual');
          }}
        >
          Remove actual annotation
        </MenuItem>
        <MenuItem
          disabled={isEqual(annotation.total, 0)}
          onClick={() => {
            setAnchorMenuRemove({ ...anchorMenuRemove, anchorEl: null });
            handleRemoveAnnotation('all');
          }}
        >
          Remove all annotations
        </MenuItem>
      </Menu>
      <Menu
        open={openMenuImport}
        anchorEl={anchorMenuImport.anchorEl}
        onClose={() => setAnchorMenuImport({ ...anchorMenuImport, anchorEl: null })}
        style={{
          left: `${anchorMenuImport.left}px`,
          top: `${anchorMenuImport.top}px`
        }}
      >
        <MenuItem
          disabled={isEmpty(videoSelected.video)}
          onClick={() => {
            setAnchorMenuImport({ ...anchorMenuImport, anchorEl: null });
            handleImportAnnotation('annotations');
          }}
        >
          Import Annotations
        </MenuItem>
        <MenuItem
          disabled={isEmpty(videoSelected.video)}
          onClick={() => {
            setAnchorMenuImport({ ...anchorMenuImport, anchorEl: null });
            handleImportAnnotation('json');
          }}
        >
          Import JSON
        </MenuItem>
      </Menu>

      <Menu
        open={openMenuExport}
        anchorEl={anchorMenuExport.anchorEl}
        onClose={() => setAnchorMenuExport({ ...anchorMenuExport, anchorEl: null })}
        style={{
          left: `${anchorMenuExport.left}px`,
          top: `${anchorMenuExport.top}px`
        }}
      >
        <MenuItem
          onClick={() =>
            setAnchorMenuExport({
              ...anchorMenuExport,
              openMenuOneByGPS: !anchorMenuExport.openMenuOneByGPS
            })
          }
        >
          Actual annotation
          {!anchorMenuExport.openMenuOneByGPS ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
        </MenuItem>
        {anchorMenuExport.openMenuOneByGPS && (
          <MenuItem
            style={{ paddingLeft: '10%' }}
            onClick={() => {
              handleExport(videoSelected.video, 'actualAnnotation');
            }}
          >
            Export without GPS time
          </MenuItem>
        )}
        {anchorMenuExport.openMenuOneByGPS && (
          <MenuItem
            style={{ paddingLeft: '10%' }}
            onClick={() => {
              handleExport(videoSelected.video, 'actualAnnotation', true);
            }}
          >
            Export with GPS time
          </MenuItem>
        )}
        <MenuItem
          onClick={() =>
            setAnchorMenuExport({
              ...anchorMenuExport,
              openMenuAllbyGPS: !anchorMenuExport.openMenuAllbyGPS
            })
          }
        >
          All annotations
          {!anchorMenuExport.openMenuAllbyGPS ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
        </MenuItem>
        {anchorMenuExport.openMenuAllbyGPS && (
          <MenuItem
            style={{ paddingLeft: '10%' }}
            onClick={() => {
              handleExport(videoSelected.video, 'annotations');
            }}
          >
            Export without GPS time
          </MenuItem>
        )}
        {anchorMenuExport.openMenuAllbyGPS && (
          <MenuItem
            style={{ paddingLeft: '10%' }}
            onClick={() => {
              handleExport(videoSelected.video, 'annotations', true);
            }}
          >
            Export with GPS time
          </MenuItem>
        )}
        <MenuItem
          onClick={() =>
            setAnchorMenuExport({
              ...anchorMenuExport,
              openMenuByTemplate: !anchorMenuExport.openMenuByTemplate
            })
          }
        >
          Annotations by templates
          {!anchorMenuExport.openMenuByTemplate ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
        </MenuItem>
        {anchorMenuExport.openMenuByTemplate && (
          <Box>
            {annotationByTemplate().map(element => {
              return (
                <MenuItem
                  key={element}
                  style={{ paddingLeft: '10%' }}
                  onClick={() => {
                    handleExport(videoSelected.video, element);
                  }}
                >{`${element}`}</MenuItem>
              );
            })}
          </Box>
        )}
        <MenuItem
          onClick={() => {
            handleExport(videoSelected.video, 'video');
          }}
        >
          Video
        </MenuItem>
      </Menu>
      {renderModal({
        openModalProp: openModalGeomotion,
        onCloseProp: () => setOpenModalGeomotion(false),
        srcProp: `${geomotionVideoLinkAPI}/projects/${videoOps.getProject(
          videoSelected.video
        )}/videos/${videoOps.getId(videoSelected.video)}`,
        titleProp: 'Geomotion'
      })}
      {renderModal({
        openModalProp: openModalGeomotionPublic,
        onCloseProp: () => setOpenModalGeomotionPublic(false),
        srcProp: `${geomotionVideoLinkAPI}/shared/videos/${videoOps.getId(videoSelected.video)}`,
        titleProp: 'Geomotion public'
      })}
      {renderModal({
        openModalProp: openModalProfile,
        onCloseProp: () => setOpenModalProfile(false),
        srcProp: !isEmpty(videoProfile) ? videoProfile.path : '',
        titleProp: 'Profile'
      })}
    </Stack>
  ];

  const constructorTable = [
    { row: 1, column: 1, elements: elementsRowOneColumnOne },
    { row: 1, column: 2, elements: elementsRowOneColumnTwo }
  ];
  const table = map(constructorTable, item => {
    return {
      row: item.row,
      column: item.column,
      rowJustifyContent: 'flex-start',
      colWidth: '50%',
      showElement: true,
      elements: item.elements
    };
  });

  React.useEffect(() => {
    if (!isEmpty(videoSelected.video) && !isEqual(videoSelected.index, -1))
      callModules(videoSelected);
  }, [videoSelected.index]);

  React.useEffect(() => {
    saveStates({
      prevVideo: videoSelected,
      totalAnnotations: annotation.total,
      prevIndexAnnotation: annotation.index
    });
  }, [annotation.index]);

  return (
    <Box sx={{ overflowX: 'hidden', overflowY: 'auto', p: 2 }}>
      {!isEditorShow && !importMode.isImport && renderTable(table)}
      {!isEmpty(videosDataBase) && (
        <>
          {!isEditorShow && !importMode.isImport && (
            <>
              <ViewAnnotationOneByOne
                onIndexChange={newIndex =>
                  setAnnotation({
                    ...annotation,
                    index: newIndex,
                    element: annotationsVideo[newIndex]
                  })
                }
                index={annotation.index}
                videoId={videoOps.getId(videoSelected.video)}
                MapProps={MapProps}
              />
              {showVideo && !isEmpty(videoSelected.video) && (
                <VideoAnnotationsMaps
                  handleSelectAnnotation={(newAnnotation, index) =>
                    setAnnotation({
                      ...annotation,
                      index,
                      element: newAnnotation
                    })
                  }
                  videoSelected={videoSelected.video}
                  indexAnnotation={annotation.index}
                  isMobile={isMobile}
                />
              )}
            </>
          )}
          {importMode.isImport && (
            <ImportAnnotationMaps
              annotationsProp={annotationsVideo}
              annotationsTemplate={videoOps.getAnnotationTemplates(videoSelected.video)}
              handleCloseImport={() => setImportMode({ isImport: false })}
              fileJson={importMode.fileJson}
              fileName={importMode.fileName}
              videoSelected={videoSelected.video}
              loading={loading}
              sizePlayer={{ x: 0, y: 0, width: 0, height: 0 }}
              timeVideoDuration={videoOps.getDefaultDurationVideo(videoSelected.video)}
            />
          )}
          {isEditorShow && (
            <AnnotationMapsEditor
              isUpdateEditor={isEditorMode.isUpdateEditor}
              annotations={annotationsVideo}
              sizePlayer={{ x: 0, y: 0, width: 0, height: 0 }}
              selectedAnnotation={annotation.element}
              videoSelected={videoSelected.video}
              annotationTemplates={videoOps.getAnnotationTemplates(videoSelected.video)}
              handleClose={() => {
                setIsEditorMode({ isEditor: false, isUpdateEditor: false });
                setShowNotesOnMap({
                  ...showNotesOnMap,
                  updateMap: !showNotesOnMap.updateMap,
                  methodEditor: 'close'
                });
              }}
              {...rest}
            />
          )}
        </>
      )}
    </Box>
  );
};
NotesComponent.defaultProps = {
  videosDataBase: [],
  isMobile: false,
  previousStates: {
    totalAnnotations: 0,
    prevIndexAnnotation: -1,
    prevVideo: { video: {}, index: -1 }
  },
  saveStates: () => {}
};
NotesComponent.propTypes = {
  videosDataBase: PropTypes.array,
  loading: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool,
  MapProps: PropTypes.object.isRequired,
  notesProps: PropTypes.object.isRequired,
  previousStates: PropTypes.object,
  saveStates: PropTypes.func
};
export default withTracker(({ notesProps }) => {
  const videosSub = Meteor.subscribe('manyvideos.annotations', notesProps.videos);
  const videosDataBase = Videos.find({
    _id: { $in: notesProps.videos },
    deleted: { $eq: 'no' }
  }).fetch();

  return {
    loading: !videosSub.ready(),
    videosDataBase
  };
})(NotesComponent);
